export default "__VITE_ASSET__Dgtu0dkP__"